import { render, staticRenderFns } from "./CampaignNotifications.vue?vue&type=template&id=d1d0e52a&scoped=true&"
import script from "./CampaignNotifications.vue?vue&type=script&lang=js&"
export * from "./CampaignNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d0e52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1d0e52a')) {
      api.createRecord('d1d0e52a', component.options)
    } else {
      api.reload('d1d0e52a', component.options)
    }
    module.hot.accept("./CampaignNotifications.vue?vue&type=template&id=d1d0e52a&scoped=true&", function () {
      api.rerender('d1d0e52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/CampaignNotifications.vue"
export default component.exports